import { ReactNode } from 'react';
import { SweepTypographyVariants } from '@sweep-io/sweep-design/dist/components/Typography/types';
import { Typography } from '@sweep-io/sweep-design';
import { useTypewriter, UseTypewriterOptions } from '../../hooks/useTypewriter';

export interface TypewriterProps extends UseTypewriterOptions {
  children: ReactNode;
  variant?: SweepTypographyVariants;
  color?: string;
}

const Typewriter = ({
  children,
  variant,
  color,
  autoStart = true,
  supportStreaming = false,
}: TypewriterProps) => {
  // Convert children to string for the typewriter hook
  const text = typeof children === 'string' ? children : String(children);

  const { displayedText } = useTypewriter(text, {
    autoStart,
    supportStreaming,
  });

  return (
    <Typography variant={variant ?? 'body'} color={color}>
      {displayedText}
    </Typography>
  );
};

export default Typewriter;
